"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _gmap_utils = _interopRequireDefault(require("../../../lib/gmap_utils"));
var _apiEnv = _interopRequireDefault(require("../../../api/api-env"));
var _apiListingsSearch = _interopRequireDefault(require("../../../api/api-listings-search"));
var _searchModule = require("../shared-components/search-module");
var _reactIntl = require("react-intl");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var withLocationDropdownHoc = function withLocationDropdownHoc(Component) {
  var HOC = /*#__PURE__*/function (_React$Component) {
    _inherits(HOC, _React$Component);
    function HOC(props) {
      var _this;
      _classCallCheck(this, HOC);
      _this = _callSuper(this, HOC, [props]);
      _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
      _this.metroClick = _this.metroClick.bind(_assertThisInitialized(_this));
      _this.poiClick = _this.poiClick.bind(_assertThisInitialized(_this));
      _this.autoComplete = _this.autoComplete.bind(_assertThisInitialized(_this));
      _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
      _this.onFocusLocation = _this.onFocusLocation.bind(_assertThisInitialized(_this));
      _this.onBlurLocation = _this.onBlurLocation.bind(_assertThisInitialized(_this));
      _this.getBrowserTimezoneOffset = _this.getBrowserTimezoneOffset.bind(_assertThisInitialized(_this));
      _this.metroClickCb = _this.metroClickCb.bind(_assertThisInitialized(_this));
      _this.showEmailDropdown = _this.showEmailDropdown.bind(_assertThisInitialized(_this));
      _this.toggleModal = _this.toggleModal.bind(_assertThisInitialized(_this));
      _this.debounceAutoComplete = _lodash.default.debounce(_this.autoComplete, 250);
      _this.onInputOnclick = _this.onInputOnclick.bind(_assertThisInitialized(_this));
      _this.poiOnLoad = _this.poiOnLoad.bind(_assertThisInitialized(_this));
      _this.initialState = {
        metros: [],
        locationPlaceholder: _this.props.intl.formatMessage({
          id: 'elements_search_module.with_location_dropdown_hoc.where',
          defaultMessage: 'Where?'
        }),
        predictions: [],
        whichDropdown: '',
        location: '',
        dataLocation: {},
        locationQuery: {},
        showModal: false,
        placeholderColor: 'placeholder-color-change'
      };
      _this.state = _this.initialState;
      return _this;
    }
    _createClass(HOC, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;
        var date = Date.now();
        var location = _lodash.default.get(this.props, 'location', '');
        _apiEnv.default.getMetros(date, function (metros) {
          var sortedMetros = _lodash.default.sortBy(metros, function (m) {
            var difference = m.standard_tz_offset + _this2.getBrowserTimezoneOffset();
            return 0 > difference ? difference * -1 : difference;
          });
          _this2.setState({
            metros: sortedMetros,
            location: location
          });
        });
        this.props.locationRef(this.typeAheadInput);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
          this.setState({
            location: this.props.location
          });
          this.props.locationRef(this.typeAheadInput);
        }
      }
    }, {
      key: "onChange",
      value: function onChange(e) {
        var _this3 = this;
        var location = e.currentTarget.value;
        this.setState({
          location: location
        }, function () {
          if (location) {
            return _this3.debounceAutoComplete(location);
          }
          _this3.debounceAutoComplete.cancel();
          return _this3.setState({
            predictions: '',
            whichDropdown: '',
            dataLocation: {},
            locationQuery: {}
          });
        });
      }
    }, {
      key: "onBlurLocation",
      value: function onBlurLocation() {
        this.setState({
          locationPlaceholder: this.props.intl.formatMessage({
            id: 'elements_search_module.with_location_dropdown_hoc.on_blur_location',
            defaultMessage: 'Where?'
          }),
          placeholderColor: this.initialState.placeholderColor
        });
      }
    }, {
      key: "onFocusLocation",
      value: function onFocusLocation() {
        this.setState({
          locationPlaceholder: this.props.intl.formatMessage({
            id: 'elements_search_module.with_location_dropdown_hoc.enter_address',
            defaultMessage: 'Enter a city or address'
          }),
          placeholderColor: ''
        });
      }
    }, {
      key: "onInputOnclick",
      value: function onInputOnclick(e) {
        if (e) {
          e.stopPropagation();
          e.preventDefault();
          e.target.select();
        }
      }
    }, {
      key: "onKeyDown",
      value: function onKeyDown(e) {
        var predictions = this.state.predictions;
        var firstOnList = document.getElementById('location-list-0') || document.getElementById('metro-list-0');
        if (40 === e.keyCode && firstOnList) {
          // If user presses the down arro\w,
          // we select the first item from the dropdown
          e.preventDefault();
          firstOnList.focus();
        } else if (13 === e.keyCode && predictions.length && firstOnList) {
          // If user hits enter, we select the first item from the dropdown,
          // and blur out of the input field
          firstOnList.click();
          e.target.blur();
        }
      }
    }, {
      key: "getBrowserTimezoneOffset",
      value: function getBrowserTimezoneOffset() {
        var currentDate = new Date();
        var gmtOffset = currentDate.getTimezoneOffset() / 60;
        return gmtOffset;
      }
    }, {
      key: "autoComplete",
      value: function autoComplete(input, callback) {
        var _this4 = this;
        if (!input || _lodash.default.isEmpty(window.google)) return null;
        var completer = _gmap_utils.default.autoCompleteService();
        var currentBounds = this.props.currentBounds;
        var bounds;
        if (currentBounds) {
          bounds = _gmap_utils.default.getBoundsFromSearchArr(currentBounds);
        }
        var options = {
          input: input,
          bounds: bounds,
          types: ['geocode']
        };
        return completer.getPlacePredictions(options, function (predictions, status) {
          if ('ZERO_RESULTS' === status) {
            _this4.setState({
              whichDropdown: 'error',
              locationQuery: {}
            });
          }
          if ('OK' === status) {
            _this4.setState({
              predictions: predictions,
              whichDropdown: 'location'
            }, function () {
              if (callback) {
                callback();
              }
            });
          }
        });
      }
    }, {
      key: "poiOnLoad",
      value: function poiOnLoad() {
        // This function runs when a location props is passed down
        var selectedPOI = this.state.predictions[0];
        var newState = {
          dataLocation: {
            placeId: selectedPOI.place_id
          }
        };
        if (this.props.searchOnMount) {
          newState.location = selectedPOI.description;
        }
        this.setState(newState, this.poiClickCb);
      }
    }, {
      key: "poiClick",
      value: function poiClick(e, listToggle) {
        if (e) {
          e.stopPropagation();
          e.preventDefault();
        }
        var predictions = this.state.predictions;
        var poiValue = _lodash.default.get(e, 'currentTarget.dataset.value', '');
        var selectedPOI = _lodash.default.filter(predictions, {
          place_id: poiValue
        })[0] || {};
        this.setState({
          location: selectedPOI.description,
          dataLocation: {
            placeId: selectedPOI.place_id
          }
        }, this.poiClickCb);
        if (_lodash.default.isFunction(listToggle)) listToggle();
      }
    }, {
      key: "metroClick",
      value: function metroClick(e, closeDropdownOrModal) {
        if (e) {
          e.stopPropagation();
          e.preventDefault();
        }
        var nickname = _lodash.default.get(e, 'currentTarget.dataset.value', '');
        var selectedMetro = _lodash.default.filter(this.state.metros, {
          nickname: nickname
        })[0] || {};
        this.setState({
          location: selectedMetro.name,
          dataLocation: {
            nickname: selectedMetro.nickname,
            map_center: selectedMetro.map_center
          }
        }, this.metroClickCb);
        if (_lodash.default.isFunction(closeDropdownOrModal)) closeDropdownOrModal();
      }
    }, {
      key: "metroClickCb",
      value: function metroClickCb() {
        var _this$state = this.state,
          location = _this$state.location,
          dataLocation = _this$state.dataLocation;
        var createSearchLoc = location.toLowerCase().replace(/\,\s/g, '--').replace(/ /g, '-');
        var locCode = {
          loc_code: createSearchLoc,
          map_center: dataLocation.map_center
        };
        this.setState({
          locationQuery: locCode
        });
        if (_lodash.default.isFunction(this.props.filterResults)) {
          this.props.filterResults(locCode);
        }
      }
    }, {
      key: "poiClickCb",
      value: function poiClickCb() {
        var _this5 = this;
        var _this$state2 = this.state,
          location = _this$state2.location,
          dataLocation = _this$state2.dataLocation;
        _gmap_utils.default.doAutoComplete(dataLocation.placeId, location, function (respObj) {
          var error = respObj.error,
            _respObj$queryObj = respObj.queryObj,
            queryObj = _respObj$queryObj === void 0 ? {} : _respObj$queryObj,
            _respObj$results = respObj.results,
            results = _respObj$results === void 0 ? [] : _respObj$results;
          if (error) {
            _this5.showEmailDropdown(results, queryObj);
          }
          return _apiListingsSearch.default.get(queryObj, null, function (listings, response) {
            // sometimes "response" returned by search API is not an object
            var bbox = _lodash.default.get(response, 'suggested_viewport_bbox');
            var newQueryObject = bbox ? _lodash.default.assign({}, queryObj, {
              viewport_bbox: "[".concat([bbox], "]")
            }) : queryObj;
            _this5.setState({
              locationQuery: newQueryObject
            });
          });
        });
      }
    }, {
      key: "showEmailDropdown",
      value: function showEmailDropdown(results, queryObj) {
        var _this6 = this;
        this.setState({
          whichDropdown: 'email',
          locationQuery: {}
        }, function () {
          _this6.typeAheadInput.toggleDropdown();
          return analyticsIntegrations.searchEmail(results, queryObj, 'search');
        });
      }
    }, {
      key: "toggleModal",
      value: function toggleModal(e, listToggle) {
        if (e) e.preventDefault();
        var showModal = this.state.showModal;
        if (_lodash.default.isFunction(listToggle)) listToggle();
        this.setState({
          showModal: !showModal
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this7 = this;
        var _this$state3 = this.state,
          _this$state3$location = _this$state3.location,
          location = _this$state3$location === void 0 ? '' : _this$state3$location,
          predictions = _this$state3.predictions,
          metros = _this$state3.metros,
          locationPlaceholder = _this$state3.locationPlaceholder,
          whichDropdown = _this$state3.whichDropdown,
          locationQuery = _this$state3.locationQuery;
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Component, {
          inputOverlayRef: function inputOverlayRef(e) {
            _this7.typeAheadInput = e;
          },
          inputRef: this.props.inputRef,
          location: location,
          locations: predictions,
          dataLocation: !_lodash.default.isEmpty(locationQuery) ? JSON.stringify(locationQuery) : null,
          onBlurLocation: this.onBlurLocation,
          onFocusLocation: this.onFocusLocation,
          onChange: this.onChange,
          onKeyDown: this.onKeyDown,
          clickMetro: this.metroClick,
          clickPoi: this.poiClick,
          toggleModal: this.toggleModal,
          locationPlaceholder: locationPlaceholder,
          metros: metros,
          whichDropdown: whichDropdown,
          inputClassName: "".concat(this.props.inputClassName, " ").concat(this.state.placeholderColor),
          inputAttributes: {
            onClick: this.onInputOnclick
          },
          addOnImage: this.props.addOnImage
        }), /*#__PURE__*/_react.default.createElement(_searchModule.LocationModal, {
          metros: this.state.metros,
          toggleModal: this.toggleModal,
          showModal: this.state.showModal,
          clickMetro: this.metroClick
        }));
      }
    }]);
    return HOC;
  }(_react.default.Component);
  HOC.propTypes = {
    searchOnMount: _propTypes.default.bool,
    filterResults: _propTypes.default.func,
    currentBounds: _propTypes.default.string,
    inputClassName: _propTypes.default.string,
    inputRef: _propTypes.default.func,
    locationRef: _propTypes.default.func,
    addOnImage: _propTypes.default.object
  };
  return (0, _reactIntl.injectIntl)(HOC);
};
var _default = exports.default = withLocationDropdownHoc;